"use client";

import { SearchTab } from "../SearchTab";
import { TabsScroller } from "../tabs-scroller";
import { getTabIcon } from "./getTabIcon";
import { OFFERS_SEARCH_STYLES } from "./constants";
import type { IOffersSearchTab } from "./types";

interface IOffersSearchTabsProps {
  tabs: IOffersSearchTab[];
  activeTabId: string;
  onTabChange?: (tabId: string) => void;
  ariaLabel: string;
  ariaLabelPrev?: string;
  ariaLabelNext?: string;
}

export function OffersSearchTabs({
  tabs,
  activeTabId,
  onTabChange,
  ariaLabel,
  ariaLabelPrev = "Previous",
  ariaLabelNext = "Next",
}: IOffersSearchTabsProps) {
  const renderTab = (tab: IOffersSearchTab) => {
    const isActive = tab.id === activeTabId;
    const icon = tab.icon ?? getTabIcon(tab.id, isActive);

    return (
      <SearchTab
        key={tab.id}
        isActive={isActive}
        label={tab.label}
        icon={icon}
        onClick={() => onTabChange?.(tab.id)}
        testId={`${tab.id}-tab`}
        role="tab"
        aria-selected={isActive}
      />
    );
  };

  return (
    <>
      <div className="hidden md:block" role="tablist" aria-label={ariaLabel}>
        <TabsScroller
          ariaLabelPrev={ariaLabelPrev}
          ariaLabelNext={ariaLabelNext}
          showArrows
          snap
          contentClassName="justify-between w-full"
        >
          {tabs.map(renderTab)}
        </TabsScroller>
      </div>

      <div
        className={OFFERS_SEARCH_STYLES.mobileTabsRow}
        role="tablist"
        aria-label={ariaLabel}
      >
        {tabs.map(renderTab)}
      </div>
    </>
  );
}
